import { IStore } from 'Store/.';

const getIsFetching = (state: IStore) => state.infoAgents.isFetchingAgents || state.infoAgents.isFetchingContent;
const getIsFetchFailed = (state: IStore) => state.infoAgents.isFetchAgentsFailed || state.infoAgents.isFetchContentFailed;
const getAgents = (state: IStore) => state.infoAgents.agents;
const getAgentsContent = (state: IStore) => state.infoAgents.content;

export {
  getIsFetching,
  getIsFetchFailed,
  getAgents,
  getAgentsContent,
};


// WEBPACK FOOTER //
// ./src/components/InfoAgents/Redux/selectors.tsx